import styled from '@benzinga/themetron';

const FusionSectionScroll = styled.div`
  & {
    -ms-overflow-style: none; /* for Internet Explorer, Edge */
    scrollbar-width: none; /* for Firefox */
  }

  &::-webkit-scrollbar {
    display: none; /* for Chrome, Safari, and Opera */
  }

  @media (max-width: 959px) {
    overflow: auto hidden;
  }
`;

export default FusionSectionScroll;
